"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import type { ComponentProps } from "react";

import type ResourceAssetIndexTemplate from "@/templates/ResourceAssetIndex";
import {
  ReadableCopy,
  ReadableIndex,
  readableFallback,
} from "@/components/readable";

const ResourceAssetIndex = dynamic(
  () => import("@/templates/ResourceAssetIndex"),
  {
    ssr: false,
    loading: readableFallback("min-h-[600px]"),
  },
);

export default function ClientOnlyResourceAssetIndex(
  props: ComponentProps<typeof ResourceAssetIndexTemplate>,
) {
  const pathname = usePathname();

  return (
    <ReadableCopy
      copy={
        <ReadableIndex
          page={props.page}
          data={props.data}
          order={props.order}
          assetType={props.assetType}
          pageSize={props.pageSize}
          pageNumber={props.pageNumber}
          category={props.category}
          pageTags={props.pageTags}
          pageSort={props.pageSort}
          pageFormat={props.pageFormat}
          isEditorial={props.isEditorial}
          pathname={pathname}
          locale={props.locale ?? "en"}
          dict={props.dict}
        />
      }
    >
      <ResourceAssetIndex {...props} />
    </ReadableCopy>
  );
}
